import { useEffect } from 'react'

export function useExtensionCleanup() {
  useEffect(() => {
    const cleanup = () => {
      // Clean all bis_ attributes efficiently
      const allElements = document.querySelectorAll('*')
      allElements.forEach(element => {
        const attrs = Array.from(element.attributes)
        const attrsToRemove = attrs.filter(attr => 
          attr.name.startsWith('bis_') || 
          attr.name === 'data-adblock-key' ||
          attr.name === 'data-adblocker' || 
          attr.name === 'data-ad-original-style'
        )
        
        attrsToRemove.forEach(attr => {
          element.removeAttribute(attr.name)
        })
      })
    }

    // Initial cleanup
    cleanup()

    // Setup MutationObserver for ongoing cleanup
    const observer = new MutationObserver((mutations) => {
      let needsCleanup = false
      
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes') {
          const attrName = mutation.attributeName
          if (attrName && (attrName.startsWith('bis_') || 
              attrName === 'data-adblock-key' || 
              attrName === 'data-adblocker' ||
              attrName === 'data-ad-original-style')) {
            needsCleanup = true
          }
        }
      })

      if (needsCleanup) {
        cleanup()
      }
    })

    // Start observing with broader attribute filter
    observer.observe(document.documentElement, {
      attributes: true,
      subtree: true,
      attributeFilter: ['bis_skin_checked', 'bis_size', 'bis_id', 'data-adblock-key', 'data-adblocker', 'data-ad-original-style']
    })

    // Cleanup function
    return () => {
      observer.disconnect()
    }
  }, [])
} 